
import { RasterBoolCatComponentProperties, RBCOption, RBCSource } from "../components/raster_bool_cat_component"

const [startYear, endYear] = [2000, 2022]

const mapbiomasSources: RBCSource[] = []
for (let year = startYear; year <= endYear; year++) {
    mapbiomasSources.push({ name: year.toString(), source: `ind:indonesia_coverage_${year}` })
}

const mapbiomasOptions: RBCOption[] = [
    { label: 'Forest Formation', value: 3 },
    { label: 'Mangrove', value: 5 },
    { label: 'Non-forest Natural Vegetation', value: 13 },
    { label: 'Rice Paddy', value: 40 },
    { label: 'Oil Palm', value: 35 },
    { label: 'Pulpwood Plantation', value: 9 },
    { label: 'Other Agriculture', value: 21 },
    { label: 'Mining Pit', value: 30 },
    { label: 'Other Non-vegetation', value: 25 },
    { label: 'Aquaculture', value: 31 },
    { label: 'River, Lake, Ocean', value: 33 },
    { label: 'Not Observed', value: 27 }
]

export const MapBiomasProperties: RasterBoolCatComponentProperties = {
    name: 'MapBiomas',
    sources: mapbiomasSources,
    sourceType: 'Year',
    combineSources: false,
    options: mapbiomasOptions
}
